import { RULE_STATUS } from '../../model/constants';
import { OrderDetailModel } from '../../../state/model/order-detail.model';

export class SetRulesCheckedRules {
	static readonly type = '[Rules] SetRulesCheckedRules';

	constructor(public payload: { uiSection: string; canSave: boolean; check: number }) {}
}
export class SetAvailableRuleSet {
	static readonly type = '[Rules] SetAvailableRuleSet';
	constructor(public rulesSets: any) {}
}
export class SetRuleSet {
	static readonly type = '[Rules] SetRuleSet';
	constructor(public orderId: any) {}
}
export class SetIsRunningRules {
	static readonly type = '[Rules] SetIsRunningRules';
	constructor(public isRunningRules: boolean) {}
}
export class SetOrdersRules {
	static readonly type = '[Rules] SetOrdersRules';
	constructor(public payload: { orderId: number; documentId: string; revised: boolean }) {}
}
export class AddManualRule {
	static readonly type = '[Rules] AddManualRule';
	constructor(public payload: { violation: any }) {}
}
export class UpdatedRuleStatus {
	static readonly type = '[Rules] UpdatedRuleStatus';
	constructor(public payload: { ruleName: string; status: RULE_STATUS }) {}
}
export class UpdatedMultipleRuleStatus {
	static readonly type = '[Rules] UpdatedMultipleRuleStatus';
	constructor(public payload: any) {}
}
export class UpdatedRuleOrders {
	static readonly type = '[Rules] UpdatedRuleOrders';
	constructor(public ordersRules: any, public orderDetailModel: OrderDetailModel) {}
}
export class UpdatedRuleViolation {
	static readonly type = '[Rules] UpdatedRuleViolation';
	constructor(public payload: any) {}
}
export class AddSrrRules {
	static readonly type = '[Rules] AddSrrRules';
	constructor(public payload: Array<any>) {}
}
export class UpdatedRulelog {
	static readonly type = '[Rules] UpdatedRuleLog';
	constructor(public payload: any) {}
}
export class CleardRulelog {
	static readonly type = '[Rules] CleardRulelog';
}
export class OnRevised {
	static readonly type = '[Rules] OnRevised';
	constructor(public onRevised: boolean) {}
}
export class RuleComapateInfo {
	static readonly type = '[Rules] RuleComapateInfo';
	constructor(public orderId: number) {}
}
export class AddComementRule {
	static readonly type = '[Rules] AddComementRule';
	constructor(public payload: { ruleName: string; notes: any }) {}
}
export class DeleteComementRule {
	static readonly type = '[Rules] DeleteComementRule';
	constructor(public payload: { ruleName: string; deletedNotes: Array<any> }) {}
}
export class DeleteStipsRule {
	static readonly type = '[Rules] DeleteStipsRule';
	constructor(public payload: { ruleName: string; deletedStips: Array<any> }) {}
}
export class AddStipRule {
	static readonly type = '[Rules] AddStipRule';
	constructor(public payload: { ruleName: string; stips: any }) {}
}
export class SetUncheckedRules {
	static readonly type = '[Rules] SetUncheckedRules';
	constructor(public uncheckedRules: boolean) {}
}
export class SetSelectedRule {
	static readonly type = '[Rules] SetSelectedRule';
	constructor(public selectedRule: any) {}
}
export class DeleteSelectedRule {
	static readonly type = '[Rules] DeleteSelectedRule';
}

export class ClearRules {
	static readonly type = '[Rules] ClearRules';
}
